import { useEffect, useState } from "react";
import { masterApi } from "@/contexts/MasterAuthContext";
import { Settings, Save } from "lucide-react";

export default function MasterSystem() {
    const [data, setData] = useState({ broadcast_message: "", maintenance_mode: false, feature_flags: {} });
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        masterApi.get("/master/system").then((r) => setData({ ...data, ...r.data }));
        // eslint-disable-next-line
    }, []);

    const save = async () => {
        setSaving(true); setMessage("");
        try {
            await masterApi.put("/master/system", data);
            setMessage("Kaydedildi");
            setTimeout(() => setMessage(""), 2500);
        } catch (e) {
            setMessage(e?.response?.data?.detail || "Hata");
        } finally { setSaving(false); }
    };

    return (
        <div data-testid="master-system">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-2 flex items-center gap-2"><Settings size={14}/> Sistem</div>
                    <h1 className="text-4xl font-extrabold tracking-tight">Sistem Ayarları</h1>
                    <p className="text-neutral-400 mt-2">Platform geneli ayarlar ve duyurular</p>
                </div>
                <button data-testid="system-save" onClick={save} disabled={saving} className="inline-flex items-center gap-2 px-5 py-3 bg-yellow-500 hover:bg-yellow-400 disabled:opacity-50 text-black font-bold uppercase tracking-wider text-sm rounded-lg">
                    <Save size={16}/> {saving ? "Kaydediliyor…" : "Kaydet"}
                </button>
            </div>

            {message && <div className="text-emerald-400 bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-3 mb-5">{message}</div>}

            <div className="space-y-6 max-w-3xl">
                <div className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
                    <h3 className="font-bold mb-3">Yayın Duyurusu (Tüm Kulüplere)</h3>
                    <textarea data-testid="broadcast-input" value={data.broadcast_message || ""} onChange={(e) => setData({ ...data, broadcast_message: e.target.value })} rows={4} className="liv-master-input" placeholder="Bakım, yeni özellik duyurusu vb." />
                    <p className="text-xs text-neutral-500 mt-2">Bu mesaj tüm kulüp panelinin üstünde gösterilir. Boş bırakırsanız gizlenir.</p>
                </div>

                <div className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
                    <h3 className="font-bold mb-3">Bakım Modu</h3>
                    <label className="flex items-center gap-3 cursor-pointer">
                        <input data-testid="maintenance-toggle" type="checkbox" checked={!!data.maintenance_mode} onChange={(e) => setData({ ...data, maintenance_mode: e.target.checked })} className="w-5 h-5" />
                        <span className="text-sm">Tüm kulüpler için bakım modunu etkinleştir</span>
                    </label>
                </div>
            </div>
            <style>{`.liv-master-input { width: 100%; background: #0a0a0a; border: 1px solid #2a2a2a; padding: 0.5rem 0.75rem; border-radius: 0.5rem; color: #fff; outline: none; font-size: 0.875rem; } .liv-master-input:focus { border-color: #f5dc4c; }`}</style>
        </div>
    );
}
